import { Flex } from '@tonic-one/react';
import Organization from '@Components/Common/Organization';
import ProvisionTable from './ProvisionTable';
import RecommendConfig from './RecommendConfig';
import RiskUser from './RiskUser';
import ThreatDetection from './ThreatDetection';

export const ThreatDetectionTab = ThreatDetection;

export const ProvisionTab = () => (
  <>
    <Flex className="tool-bar" align="center" m="24px 16px">
      <Organization allOrgItem={false} />
    </Flex>
    <ProvisionTable />
  </>
);

export const RecommendConfigTab = RecommendConfig;

export const RiskUserTab = RiskUser;
